import { createContext, useContext } from 'react'

import type { CellKey } from './cell.schema'

export const CellContext = createContext<CellKey | null>(null)

CellContext.displayName = 'CellContext'

export function useCellKey(): CellKey {
  const cellKey = useContext(CellContext)

  if (!cellKey) {
    throw new Error('useCellKey must be used inside <Cell>')
  }

  return cellKey
}
